import Frames from "@frog/source/utility/Frames.js"

export default {
    "static": require("./sniper-idle-0.png"),
    "idle": {
        "frames": Frames.run({
            "tweentime": 100,
            "images": [
                require("./sniper-idle-0.png"),
                require("./sniper-idle-0.png"),
                require("./sniper-idle-0.png"),
                require("./sniper-idle-0.png"),
                require("./sniper-idle-0.png"),
                require("./sniper-idle-1.png"),
                require("./sniper-idle-2.png"),
                require("./sniper-idle-5.png"),
                require("./sniper-idle-5.png"),
                require("./sniper-idle-5.png"),
                require("./sniper-idle-5.png"),
                require("./sniper-idle-3.png"),
                require("./sniper-idle-5.png"),
                require("./sniper-idle-5.png"),
                require("./sniper-idle-5.png"),
                require("./sniper-idle-5.png"),
                require("./sniper-idle-6.png"),
                require("./sniper-idle-7.png"),
            ]
        })
    },
    "ready": {
        "frames": Frames.run({
            "tweentime": 60,
            "images": [
                require("./sniper-selected-2.png"),
                require("./sniper-selected-3.png"),
                require("./sniper-selected-4.png"),
                require("./sniper-selected-5.png"),
                require("./sniper-selected-6.png"),
                require("./sniper-selected-7.png"),
                require("./sniper-selected-0.png"),
                require("./sniper-selected-1.png"),
                require("./sniper-selected-1.png"),
                require("./sniper-selected-1.png"),
                require("./sniper-selected-1.png"),
            ]
        })
    },
}
